import { useUserRoles } from '@/hooks/useUserRoles';

export function useIsAdmin() {
  const { isAdmin, loading, refresh } = useUserRoles();
  return { isAdmin, loading, refresh };
}
